import ApiService from "@/common/api.service";

export const OrganizationService = {
    create(params) {
        return ApiService.post("organizations/add", params);
    },
    update(id, params) {
        return ApiService.update("organizations", id, params);
    },
    delete(id) {
        return ApiService.delete("organizations", id);
    },
};
